import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CommonService } from 'src/@services/common.service';

declare const gtag: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'paybev';
  isVisibleIdleModal: boolean = false;
  subscription: any;
  userActivity: any;
  userInactive: Subject<any> = new Subject();
  currentUrl: string;

  constructor(private router: Router, public _cS: CommonService) {
    this.SetTimeoutFirst10();
    this.userInactive.subscribe(() => {
      _cS.logOut();
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-ZLRZFR2EHM', {
          page_path: event.urlAfterRedirects,
        });
        this.currentUrl = event.url;
      }
    });
  }

  stayLoggedIn() {
    this.isVisibleIdleModal = false;
  }
  SetTimeoutShowModal() {
    if (
      this.currentUrl &&
      (this.currentUrl.includes('login') ||
        this.currentUrl.includes('reset-password') ||
        this.currentUrl.includes('forgot-password') ||
        this.currentUrl.includes('verify-user') ||
        this.currentUrl.includes('verify-account') ||
        this.currentUrl.includes('activation') ||
        this.currentUrl.includes('mobile-verify') ||
        this.currentUrl.includes('setup-passkey') ||
        this.currentUrl == '/')
    ) {
      this.isVisibleIdleModal = false;
    } else {
      this.userActivity = setTimeout(() => {
        this.isVisibleIdleModal = true;
        this.SetTimeoutFinal();
      }, 1620000);
    }
  }
  SetTimeoutFinal() {
    this.userActivity = setTimeout(() => {
      this.isVisibleIdleModal = false;
      this.userInactive.next(undefined);
      this._cS.logOut();
    }, 180000);
  }
  SetTimeoutFirst10() {
    this.userActivity = setTimeout(() => {
      this.SetTimeoutShowModal();
    }, 10000);
  }
  @HostListener('keypress', ['$event'])
  @HostListener('window:mousemove', ['$event'])
  refreshUserState() {
    if (!this.isVisibleIdleModal) {
      clearTimeout(this.userActivity);
      this.SetTimeoutFirst10();
    }
  }
  ngOnInit() {}
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
